import { Course } from '../../../../types/course.type';
import { Lesson } from '../../../../types/lesson.type';
import { getLessonTraineeObserverNoteLines } from '../../../../utils/lessonInstructorUtils';

const noteStyle = { fontSize: 11, fontStyle: 'italic', opacity: 0.9 } as const;

interface CalendarTraineeObserverNoteProps {
  lesson?: Lesson;
  course?: Course;
  viewerInstructorId?: number | null;
}

export const CalendarTraineeObserverNote = ({
  lesson,
  course,
  viewerInstructorId
}: CalendarTraineeObserverNoteProps) => {
  if (!lesson || !course || viewerInstructorId == null) return null;

  const lines = getLessonTraineeObserverNoteLines(lesson, course, viewerInstructorId);
  if (lines.length === 0) return null;

  return (
    <>
      {lines.map((line) => (
        <span key={line}>
          <br />
          <span style={noteStyle}>{line}</span>
        </span>
      ))}
    </>
  );
};

export const getCalendarTraineeObserverNoteText = (
  lesson: Lesson | undefined,
  course: Course | undefined,
  viewerInstructorId: number | null | undefined
): string => {
  if (!lesson || !course || viewerInstructorId == null) return '';
  return getLessonTraineeObserverNoteLines(lesson, course, viewerInstructorId).join(' • ');
};
